import React from 'react';
import { useAppContext } from '../../../../context/AppState.jsx';
import {
	getSelectedExternals,
	getSelectedLocations,
	getSelectedSubjects,
	getUrlQueryParams,
	isSelectionInvalid,
} from '../../../../actions';
import { setUrlQueryParamForSubview } from '../../../../actions';
import {
	DataTable,
	EmptySelectionPlaceholder,
	ScatterChart,
	MapChart,
	Overview,
	RangeChart,
	TooManySelectionsPlaceholder,
	BarChart,
	AbsoluteTrendBarChart,
	DriversOfChanges,
	ComparisonScatterChart,
	SignificantChangesTable,
	CorrelationScatterChart,
	CorrelationLineChart,
	ATScatterChart,
} from '../';
import { LoadingSpinner } from '../../../../components';
import styles from './styles.css';

export default function AppRouter({ isTakingScreenshot = false }) {
	const [state, dispatch] = useAppContext();
	let urlParams = getUrlQueryParams();
	let { meas, loc, view, subview, option, showAAT } = urlParams;

	if (!state?.indexedYml || !state?.descriptors || !state?.externalData) {
		return (
			<div className={styles.spinnerWrapper}>
				<LoadingSpinner />
			</div>
		);
	}

	const errors = isSelectionInvalid(state, urlParams);
	if (errors.length > 0) {
		return <TooManySelectionsPlaceholder error={errors} />;
	}

	if (!subview) {
		setUrlQueryParamForSubview(view);
		urlParams = getUrlQueryParams();
		subview = urlParams.subview;
	}

	switch (view) {
		case 'comparison':
			return <ComparisonScatterChart state={state} urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
		case 'overview':
			return <Overview state={state} isTakingScreenshot={isTakingScreenshot} />;
		case 'graph':
			if (typeof subview == 'undefined' || subview === 'score') {
				if (typeof option === 'undefined' || option === 'line') {
					return <RangeChart state={state} urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
				}
				if (option === 'bar') {
					return <BarChart state={state} urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
				}
			}
			if (subview === 'absoluteTrend' && option === 'bar') {
				return <AbsoluteTrendBarChart state={state} urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
			} else if (subview === 'absoluteTrend' && option === 'scatter') {
				return (
					<ATScatterChart
						state={state}
						urlParams={urlParams}
						isTakingScreenshot={isTakingScreenshot}
						dispatch={dispatch}
					/>
				);
			}
			if (subview === 'annualAvgTrend') {
				return <ScatterChart state={state} urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
			}
			if (subview === 'correlation' && option === 'line') {
				return <CorrelationLineChart state={state} urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
			} else if (subview === 'correlation' && option === 'scatter') {
				return <CorrelationScatterChart state={state} urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
			}
		case 'table':
			if (subview === 'score' && showAAT == 4) {
				return <SignificantChangesTable urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
			}
			if (subview === 'score' && showAAT == 3) {
				return <DriversOfChanges urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
			}
			if (subview === 'changes') {
				return <SignificantChangesTable urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
			}
			return <DataTable urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
		case 'map':
			return <MapChart urlParams={urlParams} isTakingScreenshot={isTakingScreenshot} />;
		default:
			break;
	}
}
